module.exports = __webpack_public_path__ + "e23affd710be91bdef94a227a44bf2e0.otf";